import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BannersConfig } from '@frontend/sports/common/client-config-data-access';
import { CookieProvider } from '@frontend/sports/common/core/utils/cookie-provider';
import { UserService } from '@frontend/sports/user/feature';
import { AppInfoConfig, DeviceService, Page, UrlService } from '@frontend/vanilla/core';

import { LaunchSource } from '../cross-sell-data/cross-sell-data.model';
import { ChannelIds } from './banner.model';

@Injectable({ providedIn: 'root' })
export class GamesService {
    culturePattern = '{culture}';
    langPattern = '{lang}';

    constructor(
        private bannerConfig: BannersConfig,
        private urlService: UrlService,
        private page: Page,
        private userService: UserService,
        private deviceService: DeviceService,
        private appInfoConfig: AppInfoConfig,
        private cookieProvider: CookieProvider,
    ) {}

    getLaunchUrl(name: string, launchSource: LaunchSource = LaunchSource.Gyml): string {
        if (!this.deviceService.isMobile) {
            let url = this.bannerConfig.games.launchUrl;
            url = this.formatUrlForDesktop(url, name, launchSource);

            return this.urlService.parse(url.toString()).absUrl();
        } else {
            let url = new HttpParams({ fromString: this.formatUrl(this.bannerConfig.games.launchUrl) + '?' });

            url = url.set('gameVariantName', name);
            url = url.set('langId', this.getPageCulture());
            url = url.set('invokerProduct', 'BETTING');
            url = url.set('channelId', this.deviceService.isiOS ? ChannelIds.IOS : ChannelIds.Android);

            if (this.bannerConfig.appendSessionKey) {
                url = url.set('ssoKey', this.userService.ssoToken === null ? '' : this.userService.ssoToken.toString());
            } else {
                url = url.set('&sessionKey={sessionKey}', '');
                this.cookieProvider.setCookie('ssoToken', this.userService.ssoToken as string, { expires: 1 });
            }

            url = url.set('lobbyURL', this.formatUrl(this.bannerConfig.parentUrl));
            url = url.set('keepAliveURL', this.formatUrl(this.bannerConfig.keepAliveUrl));
            url = url.set('depositURL', this.formatUrl(this.bannerConfig.depositUrl));
            url = url.set('parentUrl', this.formatUrl(this.bannerConfig.parentUrl));
            url = url.set('rgURL', this.formatUrl(this.bannerConfig.responsibleGamingUrl));
            if (this.page.homePage) {
                url = url.set('returnUrl', this.page.homePage);
            }
            url = url.set('lobbyType', this.bannerConfig.lobbyType);
            url = url.set('clickTimeStamp', this.getTimeStamp());

            return this.urlService.parse(url.toString()).absUrl();
        }
    }

    private getPageCulture(): string {
        return this.page.culture.replace('-', '_');
    }

    private formatUrl(url: string): string {
        const cultureRegex = new RegExp(this.culturePattern);
        const langRegex = new RegExp(this.langPattern);

        if (cultureRegex.test(url)) {
            url = url.replace(this.culturePattern, this.getPageCulture());
        }

        if (langRegex.test(url)) {
            url = url.replace(this.langPattern, this.page.lang);
        }

        return url;
    }

    private formatUrlForDesktop(url: string, name: string, launchSource: LaunchSource): string {
        url = url.replace('{SL}', this.getPageCulture());
        url = url.replace('{CASINO_GAME_NAME}', name);
        url = url.replace('{invokerProduct}', 'BETTING');
        url = url.replace('{invokerChannel}', ChannelIds.WC);
        url = url.replace('{lang}', this.getPageCulture());
        url = url.replace('{currency}', this.userService.currency);
        url = url.replace('{launchSource}', launchSource.toString());

        if (this.bannerConfig.appendSessionKey) {
            url = url.replace('{sessionKey}', this.userService.ssoToken as string);
        } else {
            url = url.replace('&sessionKey={sessionKey}', '');
            this.cookieProvider.setCookie('ssoToken', this.userService.ssoToken as string, { expires: 1 });
        }
        url = url.replace('{hostUrl}', this.page.homePage);
        url = url.replace('{frontend}', this.appInfoConfig.frontend);
        url = url.replace('{brand}', this.appInfoConfig.brand);
        url = url.replace('{PortalLanguage}', this.page.culture);
        url = url.replace('{clicktime}', this.getTimeStamp());

        return url;
    }

    private getTimeStamp(): string {
        return new Date().getTime().toString();
    }
}
